module.exports = __webpack_public_path__ + "img/table.18e53095.svg";